import type {
	Components,
} from '@mui/material'

export const materialUISkeletonTheme: {
	components: Components
} = {
	components: {
		MuiSkeleton: {
			defaultProps: {
				animation: 'wave',
			},
		},
	},
}
